import { IJsonQuery } from '../types/jsonQuery';
import { JsonQuery } from '../../../JsonQuery';
import { TModifier } from '../types/modifier';

export function modifyJsonQuery(jsonQuery: IJsonQuery, modifiers: [TModifier, ...TModifier[]]): IJsonQuery {
  const jq = new JsonQuery(jsonQuery);

  modifiers.forEach(modifier => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // tslint:disable-next-line:no-any
    (jq[modifier.action] as any)(...modifier.arguments);
  });

  return jq.toJSON();
}
